import { Modal } from "@mui/material";
import React, { useEffect } from "react";
import styles from "./AcknowledgeSendEmail.module.scss";
import { sendEmailService } from "../../../services/ViewReportServices";

const AcknowledgeSendEmail = ({
  openAcknowledgeSendEmail,
  closeAcknowledgeSendEmail,
  refresh
}) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    closeAcknowledgeSendEmail();
  };
  useEffect(() => {
    if (
      openAcknowledgeSendEmail &&
      openAcknowledgeSendEmail.open &&
      openAcknowledgeSendEmail.sessionId
    ) {
      handleOpen();
    }
  }, [openAcknowledgeSendEmail]);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={styles.AcknowledgeSendEmailContainer}
    >
      <div className="bg-white w-[80vw] h-auto max-w-[500px] my-[100px] rounded-[10px] outline-none p-6">
        <div className="text-[#101828]  font-semibold text-xl leading-9 mb-5 text-center">
          Are you sure you want to send this email?
        </div>
        <div className="flex justify-center gap-4">
          <button
            className="
            text-[#fff]
            font-normal
            text-sm
            leading-5
            h-[30px]
            w-[80px]
            border-[1px]
            border-[#788CFC]
            rounded-[5px]
            bg-[#788CFC]
            transition
            duration-300
            ease-in-out
            flex
            justify-center
            items-center
          "
            onClick={() => {
              sendEmailService(openAcknowledgeSendEmail.sessionId).then(
                (res) => {
                  handleClose();
                  refresh();
                }
              );
            }}
          >
            Send
          </button>
          <button
            className="
            text-[#788CFC]
            font-normal
            text-sm
            leading-5
            h-[30px]
            w-[80px]
            border-[1px]
            border-[#788CFC]
            rounded-[5px]
            transition
            duration-300
            ease-in-out
            flex
            justify-center
            items-center
            "
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AcknowledgeSendEmail;
